import React from 'react'
import { Button, Card, Layout, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title, Paragraph, Text } = Typography

/**
 * صفحة سياسة الخصوصية (عربي) — للاستخدام في متجر التطبيقات وواجهة الويب.
 * يمكن تحديث «آخر تحديث» عند تغيير الممارسات.
 */
export default function PrivacyPolicy() {
    return (
        <Layout style={{ minHeight: '100vh', background: '#f4ede3' }}>
            <Layout.Content style={{ padding: 'clamp(16px, 4vw, 32px)', maxWidth: 840, margin: '0 auto', width: '100%' }}>
                <div dir="rtl" lang="ar" style={{ textAlign: 'right' }}>
                    <div style={{ marginBottom: 20 }}>
                        <Link to="/">
                            <Button type="link" style={{ paddingInline: 0 }}>← العودة إلى الرئيسية</Button>
                        </Link>
                    </div>

                    <Card styles={{ body: { padding: 'clamp(20px, 4vw, 32px)' } }}>
                        <Title level={2} style={{ marginTop: 0 }}>سياسة الخصوصية</Title>
                        <Text type="secondary">تطبيق وموقع لين غو</Text>
                        <Paragraph style={{ marginTop: 8 }}>
                            <Text strong>آخر تحديث:</Text> ١٥ أبريل ٢٠٢٦
                        </Paragraph>

                        <Title level={4}>١. مقدمة</Title>
                        <Paragraph>
                            نحن في <Text strong>لين غو</Text> نلتزم بحماية خصوصيتك. توضح هذه السياسة كيفية جمعنا
                            واستخدامنا والاحتفاظ بمعلوماتك عند استخدامك لموقعنا الإلكتروني
                            (<Text code>leen-go.com</Text>) وتطبيق الجوال LeenGo المرتبط بالخدمة، وخدمات الطلب
                            والتوصيل والدعم.
                        </Paragraph>

                        <Title level={4}>٢. المسؤول عن البيانات</Title>
                        <Paragraph>
                            الجهة المسؤولة عن معالجة البيانات الشخصية في إطار هذه الخدمة هي مشغل منصة لين غو.
                            للاستفسارات المتعلقة بالخصوصية يمكنك التواصل معنا عبر القنوات المعتمدة في الموقع أو التطبيق
                            (مثل واتساب أو نموذج التواصل إن وُجد).
                        </Paragraph>

                        <Title level={4}>٣. البيانات التي قد نجمعها</Title>
                        <Paragraph>اعتماداً على استخدامك للخدمة، قد تشمل البيانات على سبيل المثال لا الحصر:</Paragraph>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li><Text strong>بيانات الحساب والتواصل:</Text> رقم الهاتف المستخدم لتسجيل الدخول أو إكمال الطلب عبر رمز التحقق (OTP).</li>
                            <li><Text strong>بيانات الطلب:</Text> المنتجات المطلوبة، العناوين أو منطقة التوصيل، ملاحظات الطلب، وسجل الطلبات.</li>
                            <li><Text strong>بيانات الجهاز والتطبيق (اختيارية):</Text> معرّفات تقنية لإرسال الإشعارات (مثل رمز FCM) إذا منحت الإذن بالإشعارات في التطبيق.</li>
                            <li><Text strong>بيانات الاستخدام:</Text> معلومات تقنية عامة مثل نوع المتصفح أو الجهاز، وأحياناً بيانات زيارة مجمّعة لتحسين الخدمة (إن فُعّلت).</li>
                        </ul>

                        <Title level={4}>٤. أغراض استخدام البيانات</Title>
                        <Paragraph>نستخدم البيانات من أجل:</Paragraph>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>إنشاء الحساب وتسجيل الدخول والتحقق من الهوية عبر OTP.</li>
                            <li>معالجة الطلبات والدفع والتوصيل والتواصل معك بخصوص الطلب.</li>
                            <li>إرسال إشعارات متعلقة بالخدمة (مثل حالة الطلب) عند موافقتك حيث ينطبق ذلك.</li>
                            <li>تحسين الأمان، ومنع الاحتيال، والامتثال للالتزامات القانونية.</li>
                            <li>دعم العملاء والرد على الاستفسارات.</li>
                        </ul>

                        <Title level={4}>٥. الأساس القانوني للمعالجة</Title>
                        <Paragraph>
                            تعتمد المعالجة على ضرورة تنفيذ العقد (تقديم الخدمة والطلب)، ومصالحنا المشروعة في تشغيل
                            المنصة بأمان، وفي بعض الحالات على موافقتك (مثل الإشعارات التسويقية إن وُجدت وتم طلب الموافقة صراحة).
                        </Paragraph>

                        <Title level={4}>٦. مشاركة البيانات مع أطراف ثالثة</Title>
                        <Paragraph>
                            لا نبيع بياناتك الشخصية. قد نشارك البيانات مع مزودي خدمات يعملون لحسابنا فقط لحاجة التشغيل،
                            مثل:
                        </Paragraph>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>مقدمو استضافة البنية التحتية والخوادم وقواعد البيانات.</li>
                            <li>خدمات الرسائل والإشعارات (مثل Google Firebase لإشعارات التطبيق) وفق سياسات المزود.</li>
                            <li>أي جهة مطلوب قانوناً الكشف لها.</li>
                        </ul>

                        <Title level={4}>٧. التخزين والاحتفاظ</Title>
                        <Paragraph>
                            نحتفظ بالبيانات للمدة اللازمة لتقديم الخدمة والوفاء بالالتزامات القانونية والمحاسبية،
                            ثم نحذفها أو ننكّهها عندما لا تعد ضرورية.
                        </Paragraph>

                        <Title level={4}>٨. الأمان</Title>
                        <Paragraph>
                            نطبّق تدابير تقنية وتنظيمية معقولة لحماية البيانات. لا يوجد نقل أو تخزين آمن بنسبة ١٠٠٪
                            عبر الإنترنت؛ لذلك نشجعك على حماية جهازك وعدم مشاركة رموز التحقق مع أحد.
                        </Paragraph>

                        <Title level={4}>٩. حقوقك</Title>
                        <Paragraph>حسب القوانين المعمول بها، قد يحق لك طلب:</Paragraph>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>الاطلاع على بياناتك أو تصحيحها.</li>
                            <li>
                                <Text strong>حذف الحساب:</Text> يمكنك حذف حسابك <Text strong>مباشرة من تطبيق LeenGo (لين غو)</Text> دون
                                الحاجة لمراسلتنا (انظر القسم ١٤ أدناه وصفحة{' '}
                                <Link to="/account-deletion">حذف الحساب والبيانات</Link>). يمكنك أيضاً طلب تقييد المعالجة حيث ينطبق ذلك.
                            </li>
                            <li>سحب الموافقة عندما تعتمد المعالجة على الموافقة.</li>
                        </ul>
                        <Paragraph>
                            لطلبات أخرى أو عند تعذّر استخدام التطبيق، يمكنك التواصل معنا عبر قنوات الدعم المعروضة في الموقع أو التطبيق.
                        </Paragraph>

                        <Title level={4}>١٠. ملفات تعريف الارتباط والتقنيات المشابهة</Title>
                        <Paragraph>
                            قد يستخدم الموقع تقنيات ضرورية لتشغيل الجلسة والتفضيلات. يمكنك ضبط متصفحك لتقليل
                            ملفات تعريف الارتباط؛ قد يؤثر ذلك على بعض الوظائف.
                        </Paragraph>

                        <Title level={4}>١١. الأطفال</Title>
                        <Paragraph>
                            الخدمة غير موجهة لمن دون سن يتطلب القانون موافقة ولي أمر. إذا علمت أننا جمعنا بيانات طفل
                            دون حق، يرجى التواصل معنا لاتخاذ الإجراء المناسب.
                        </Paragraph>

                        <Title level={4}>١٢. تعديلات على هذه السياسة</Title>
                        <Paragraph>
                            قد نحدّث هذه السياسة من وقت لآخر. سننشر النسخة المحدّثة على هذه الصفحة ونحدّث تاريخ
                            «آخر تحديث». استمرارك باستخدام الخدمة بعد التعديل يعني موافقتك حيث ينطبق القانون.
                        </Paragraph>

                        <Title level={4}>١٣. التواصل</Title>
                        <Paragraph>
                            لأي سؤال حول سياسة الخصوصية، يرجى التواصل معنا عبر وسائل التواصل المتاحة في الموقع أو التطبيق.
                        </Paragraph>

                        <Title level={4}>١٤. حذف الحساب</Title>
                        <Paragraph>
                            <Text strong>من داخل تطبيق لين غو (الطريقة الأساسية):</Text> بعد تسجيل الدخول، افتح{' '}
                            <Text strong>الملف الشخصي</Text>، ثم اختر <Text strong>«حذف الحساب نهائياً»</Text>،
                            واقرأ التحذيرات ثم أكّد الحذف في خطوتين. يُحذف حسابك من خوادمنا فوراً بعد نجاح العملية،
                            وتُزال جلستك من الجهاز. إن وُجدت منطقة توصيل محفوظة على الجهاز، قد يُعاد تسجيل الجهاز لإشعارات
                            الضيوف فقط دون حساب. <Text strong>سجلات الطلبات السابقة</Text> قد تبقى مخزّنة لأغراض
                            محاسبية وتشغيلية مع <Text strong>فك ارتباطها بحسابك</Text> (لا يعود الطلب مرتبطاً بحساب محذوف).
                        </Paragraph>
                        <Paragraph>
                            لمزيد من التفاصيل وخيارات الدعم (مثل التواصل عند تعذّر الدخول)، راجع صفحة{' '}
                            <Link to="/account-deletion">حذف الحساب والبيانات</Link>.
                        </Paragraph>
                    </Card>
                </div>
            </Layout.Content>
        </Layout>
    )
}
